import { useTranslation } from "react-i18next"

export type HourReportingRolesTranslations = typeof defaultTranslations

const defaultTranslations = {
  tableAriaLabel: "Hour reporting roles table",
  reporterHeaderText: "Reporter",
  checkersHeaderText: "Checkers",
  approversHeaderText: "Approvers",
  checkersInputLabel: "Add checker",
  approversInputLabel: "Add approver",
  emptyRolePlaceholder: "None assigned",
  noOptionsText: "No members available",
  noHourReportingRolesText: "No hour reporting permissions are available for these roles.",
  errorLoadingHourReportingRolesText: "Error loading hour reporting roles.",
  checkerCountLabel: "checkers",
  approverCountLabel: "approvers",
  checkedReportersHeaderText: "Members whose hour reports {memberName} checks",
  approvedReportersHeaderText: "Members whose hour reports {memberName} approves",
  roleDetailsTitleText: "Hour reporting responsibilities",
  roleDetailsDescriptionText: "These members' reported hours are checked or approved by {memberName}.",
  noCheckedReportersText: "No reporters are assigned to this checker.",
  noApprovedReportersText: "No reporters are assigned to this approver.",
  closeDialogLabel: "Close details",
  membershipCheckerInvitationMustBeAccepted:
    "A checker must have accepted their membership inviation before they can be assigned to check reports.",
}

export const useTranslations = (): HourReportingRolesTranslations => {
  const { t: tOrg } = useTranslation("org")

  return {
    tableAriaLabel: tOrg("orgMembershipsPage.hourReportingRoles.tableAriaLabel", {
      defaultValue: defaultTranslations.tableAriaLabel,
    }),
    reporterHeaderText: tOrg("orgMembershipsPage.hourReportingRoles.reporterHeaderText", {
      defaultValue: defaultTranslations.reporterHeaderText,
    }),
    checkersHeaderText: tOrg("orgMembershipsPage.hourReportingRoles.checkersHeaderText", {
      defaultValue: defaultTranslations.checkersHeaderText,
    }),
    approversHeaderText: tOrg("orgMembershipsPage.hourReportingRoles.approversHeaderText", {
      defaultValue: defaultTranslations.approversHeaderText,
    }),
    checkersInputLabel: tOrg("orgMembershipsPage.hourReportingRoles.checkersInputLabel", {
      defaultValue: defaultTranslations.checkersInputLabel,
    }),
    approversInputLabel: tOrg("orgMembershipsPage.hourReportingRoles.approversInputLabel", {
      defaultValue: defaultTranslations.approversInputLabel,
    }),
    emptyRolePlaceholder: tOrg("orgMembershipsPage.hourReportingRoles.emptyRolePlaceholder", {
      defaultValue: defaultTranslations.emptyRolePlaceholder,
    }),
    noOptionsText: tOrg("orgMembershipsPage.hourReportingRoles.noOptionsText", {
      defaultValue: defaultTranslations.noOptionsText,
    }),
    noHourReportingRolesText: tOrg("orgMembershipsPage.noHourReportingRolesText", {
      defaultValue: defaultTranslations.noHourReportingRolesText,
    }),
    errorLoadingHourReportingRolesText: tOrg(
      "orgMembershipsPage.hourReportingRoles.errorLoadingHourReportingRolesText",
      {
        defaultValue: defaultTranslations.errorLoadingHourReportingRolesText,
      }
    ),
    checkerCountLabel: tOrg("orgMembershipsPage.hourReportingRoles.checkerCountLabel", {
      defaultValue: defaultTranslations.checkerCountLabel,
    }),
    approverCountLabel: tOrg("orgMembershipsPage.hourReportingRoles.approverCountLabel", {
      defaultValue: defaultTranslations.approverCountLabel,
    }),
    checkedReportersHeaderText: tOrg("orgMembershipsPage.hourReportingRoles.checkedReportersHeaderText", {
      defaultValue: defaultTranslations.checkedReportersHeaderText,
    }),
    approvedReportersHeaderText: tOrg("orgMembershipsPage.hourReportingRoles.approvedReportersHeaderText", {
      defaultValue: defaultTranslations.approvedReportersHeaderText,
    }),
    roleDetailsTitleText: tOrg("orgMembershipsPage.hourReportingRoles.roleDetailsTitleText", {
      defaultValue: defaultTranslations.roleDetailsTitleText,
    }),
    roleDetailsDescriptionText: tOrg("orgMembershipsPage.hourReportingRoles.roleDetailsDescriptionText", {
      defaultValue: defaultTranslations.roleDetailsDescriptionText,
    }),
    noCheckedReportersText: tOrg("orgMembershipsPage.hourReportingRoles.noCheckedReportersText", {
      defaultValue: defaultTranslations.noCheckedReportersText,
    }),
    noApprovedReportersText: tOrg("orgMembershipsPage.hourReportingRoles.noApprovedReportersText", {
      defaultValue: defaultTranslations.noApprovedReportersText,
    }),
    closeDialogLabel: tOrg("orgMembershipsPage.hourReportingRoles.closeDialogLabel", {
      defaultValue: defaultTranslations.closeDialogLabel,
    }),
    membershipCheckerInvitationMustBeAccepted: tOrg(
      "orgMembershipsPage.hourReportingRoles.membershipCheckerInvitationMustBeAccepted",
      {
        defaultValue: defaultTranslations.membershipCheckerInvitationMustBeAccepted,
      }
    ),
  }
}
